(() => {
  const swatchSelector = '[data-okg-card-metal-swatch]';
  const toggleSelector = '[data-okg-card-metal-toggle]';
  const labelSelector = '[data-okg-card-metal-label]';
  const featuredCollectionSelector = "[id$='__featured_collection'], [id$='__featured_collection_engagement'], [id$='__product-grid']";
  const cardContentSelector = '.product-card-wrapper .card--standard > .card__content';
  const activeClass = 'is-active';
  const collapsedClass = 'is-collapsed';
  let equalizeFrame = null;
  let gridObserver = null;

  const equalizeCardContentHeights = () => {
    document.querySelectorAll(featuredCollectionSelector).forEach((section) => {
      const contents = Array.from(section.querySelectorAll(cardContentSelector));
      let maxHeight = 0;

      contents.forEach((content) => {
        content.style.minHeight = '';
      });

      contents.forEach((content) => {
        maxHeight = Math.max(maxHeight, content.getBoundingClientRect().height);
      });

      contents.forEach((content) => {
        content.style.minHeight = `${Math.ceil(maxHeight)}px`;
      });
    });
  };

  const scheduleEqualizeCardContentHeights = () => {
    if (equalizeFrame) window.cancelAnimationFrame(equalizeFrame);
    equalizeFrame = window.requestAnimationFrame(() => {
      equalizeFrame = null;
      equalizeCardContentHeights();
    });
  };

  const positionLabel = (swatches, swatch) => {
    if (!swatches || !swatch) return;

    swatches.style.setProperty('--okg-card-metal-label-offset', `${swatch.offsetLeft}px`);
  };

  const updateCardImages = (card, swatch) => {
    const imageSrc = swatch.dataset.imageSrc;
    if (!imageSrc) return;

    const images = card.querySelectorAll('.media--hover-effect img');
    images.forEach((image) => {
      image.src = imageSrc;

      if (swatch.dataset.imageSrcset) {
        image.srcset = swatch.dataset.imageSrcset.trim();
      } else {
        image.removeAttribute('srcset');
      }

      if (swatch.dataset.imageAlt) {
        image.alt = swatch.dataset.imageAlt;
      }
    });
  };

  const updateCardLinks = (card, swatch) => {
    const variantUrl = swatch.dataset.variantUrl;
    if (!variantUrl) return;

    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      link.href = variantUrl;
    });
  };

  const formatCardMoney = (cents, swatch) => {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '';

    const currencyCode = swatch.dataset.currencyCode || window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || navigator.language || 'en-US';
    const hasCents = amount % 100 !== 0;
    const money = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0,
    }).format(amount / 100);

    return swatch.dataset.currencyCodeEnabled === 'true' ? `${money} ${currencyCode}` : money;
  };

  const updateCardPrice = (card, swatch) => {
    const price = card.querySelector('.card-information > .price');
    if (!price || !swatch.dataset.priceCents) return;

    const isOnSale = swatch.dataset.priceOnSale === 'true';
    const isAvailable = swatch.dataset.variantAvailable !== 'false';
    const money = formatCardMoney(swatch.dataset.priceCents, swatch);
    const compareMoney = isOnSale ? formatCardMoney(swatch.dataset.comparePriceCents, swatch) : '';
    const regularPrice = price.querySelector('.price__regular .price-item--regular');
    const salePrice = price.querySelector('.price__sale .price-item--sale');
    const compareAtPrice = price.querySelector('.price__sale .price-item--regular');

    price.classList.toggle('price--on-sale', isOnSale);
    price.classList.toggle('price--sold-out', !isAvailable);

    if (regularPrice) {
      regularPrice.textContent = money;
    }

    if (salePrice) {
      salePrice.textContent = money;
    }

    if (compareAtPrice) {
      compareAtPrice.textContent = compareMoney;
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(toggleSelector);
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const swatches = toggle.closest('.okg-card-metal-swatches');
      if (!swatches) return;

      const isCollapsed = swatches.classList.toggle(collapsedClass);
      toggle.textContent = isCollapsed ? '>>' : '<<';
      toggle.setAttribute('aria-expanded', String(!isCollapsed));
      toggle.setAttribute('aria-label', isCollapsed ? 'Show more metal colors' : 'Show fewer metal colors');
      positionLabel(swatches, swatches.querySelector(`${swatchSelector}.${activeClass}`) || swatches.querySelector(swatchSelector));
      scheduleEqualizeCardContentHeights();
      return;
    }

    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const swatches = swatch.closest('.okg-card-metal-swatches');
    const card = swatch.closest('.product-card-wrapper');
    if (!swatches || !card) return;

    swatches.querySelectorAll(swatchSelector).forEach((item) => {
      const isActive = item === swatch;
      item.classList.toggle(activeClass, isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });

    const label = swatches.querySelector(labelSelector);
    if (label && swatch.dataset.metalLabel) {
      label.textContent = swatch.dataset.metalLabel;
    }

    positionLabel(swatches, swatch);
    updateCardImages(card, swatch);
    updateCardLinks(card, swatch);
    updateCardPrice(card, swatch);
    scheduleEqualizeCardContentHeights();
  });

  const init = () => {
    document.querySelectorAll('.okg-card-metal-swatches').forEach((swatches) => {
      positionLabel(swatches, swatches.querySelector(`${swatchSelector}.${activeClass}`) || swatches.querySelector(swatchSelector));
    });
    scheduleEqualizeCardContentHeights();
  };

  const watchProductGridUpdates = () => {
    if (gridObserver || !document.body) return;

    gridObserver = new MutationObserver((mutations) => {
      const hasCardUpdates = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;

          return node.matches?.('.product-card-wrapper, #ProductGridContainer') || node.querySelector?.('.product-card-wrapper');
        })
      );

      if (hasCardUpdates) init();
    });

    gridObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      watchProductGridUpdates();
    }, { once: true });
  } else {
    init();
    watchProductGridUpdates();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init, { passive: true });
  window.addEventListener('load', scheduleEqualizeCardContentHeights, { once: true });

  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleEqualizeCardContentHeights);
  }
})();
